<template>
  <v-theme-provider dark>
    <base-section
      id="banner-ahorro"
      class="secondary"
      space="40"
    >
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <base-title
              :space="$vuetify.breakpoint.mdAndUp ? 0 : 4"
              title="RECUERDA QUE AHORRAS AGUA, TIEMPO Y DINERO"
            />

            <base-body space="0">
              <span class="white--text">
                Paint Clean Box ha sido concebido y desarrollado por profesionales de la pintura que valoran su tiempo.
              </span>
            </base-body>
          </v-col>
        </v-row>
      </v-container>
    </base-section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'SectionContactUs',
  }
</script>
